import { Component, inject, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sign-in-modal',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './sign-in-modal.component.html',
})
export class SignInModalComponent {
  authService = inject(AuthService);

  isOpen = input.required<boolean>();
  success = output<void>();
  closed = output<void>();

  email = '';
  password = '';
  error = signal<string>('');
  showPassword = signal(false);
  isClosing = signal(false);

  togglePasswordVisibility(): void {
    this.showPassword.update((visible) => !visible);
  }

  async handleSubmit(): Promise<void> {
    this.error.set('');

    if (!this.email || !this.password) {
      this.error.set('Please fill in all fields');
      return;
    }

    try {
      await this.authService.login(
        { email: this.email, password: this.password },
        { navigateOnSuccess: false }
      );
      this.email = '';
      this.password = '';
      this.fadeOutThen(() => this.success.emit());
    } catch (error: any) {
      this.error.set(error.error?.message || 'Sign in failed. Please try again.');
    }
  }

  onBackdropClick(): void {
    this.fadeOutThen(() => this.closed.emit());
  }

  private fadeOutThen(after: () => void): void {
    this.isClosing.set(true);
    setTimeout(() => {
      this.isClosing.set(false);
      after();
    }, 150);
  }
}
